export const getIconForTopicBySourceId = (sourceId: string) => {
  const sourceIdToTopicNameMap = {
    '/': 'Featured',
    'Support': 'Support',
    '115000867647': 'Personalization',
    '115000874048': 'Analytics',
    '115000867867': 'PeerComparison',
    '115000867667': 'Campaigns',
    '18073014919195': 'Cdp',
    '4414879524891': 'Coupons',
    '14234163769755': 'EmailAndSms',
    '115000873988': 'Compliance',
    '115000312411': 'Flows',
    '115000032731': 'Integrations',
    '16638219724187': 'Reviews',
    '360000190711': 'Forms',
    '29173800271259': 'Sms',
    '34141283979931': 'CustomerHub',
  } as const;

  const foundIcon = sourceIdToTopicNameMap[sourceId as keyof typeof sourceIdToTopicNameMap];

  if (foundIcon) {
    return foundIcon;
  }

  return 'Text';
};
